import { render } from "./GoBackTopButton.vue?vue&type=template&id=60eb62ec&scoped=true"
import script from "./GoBackTopButton.vue?vue&type=script&lang=js"
export * from "./GoBackTopButton.vue?vue&type=script&lang=js"

import "./GoBackTopButton.vue?vue&type=style&index=0&id=60eb62ec&scoped=true&lang=css"

import exportComponent from "D:\\gltech\\NewGrowthWebV2\\code\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60eb62ec"]])

export default __exports__